import { render, staticRenderFns } from "./formSaidaReceita.vue?vue&type=template&id=e938db66&scoped=true"
import script from "./formSaidaReceita.vue?vue&type=script&lang=js"
export * from "./formSaidaReceita.vue?vue&type=script&lang=js"
import style0 from "./formSaidaReceita.vue?vue&type=style&index=0&id=e938db66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e938db66",
  null
  
)

export default component.exports